module.exports = __webpack_public_path__ + "img/determine.0d94d205.png";